import {ref, computed} from 'vue';
import {Ref} from '@vue/reactivity';

class DimensionComposition {
    private _timeout: number = 0;
    private _mapElementWidth: Ref<number> = ref(0);
    private _mapElementHeight: Ref<number> = ref(0);
    private _listElementWidth: Ref<number> = ref(0);
    private _listElementHeight: Ref<number> = ref(0);
    private _listInnerElementWidth: Ref<number> = ref(0);
    private _listInnerElementHeight: Ref<number> = ref(0);
    private _mapElement: Ref<HTMLElement | undefined> = ref(undefined);
    private _listElement: Ref<HTMLElement | undefined> = ref(undefined);
    private _listInnerElement: Ref<HTMLElement | undefined> = ref(undefined);

    public offset = computed(() => {
        const padding = 40;
        const x = (this.mapElementWidth - this.listElementWidth) / 2 + padding;
        const y = padding;

        return {
            left: x + (this.check() ? 0 : this.listInnerElementWidth),
            top: y,
            right: x,
            bottom: y
        };
    });

    constructor() {
        window.addEventListener('resize', () => {
            window.clearTimeout(this._timeout);

            this._timeout = window.setTimeout(() => {
                this.setMapElementSize();
                this.setListElementSize();
                this.setListInnerElementSize();
            }, 50);
        });
    }

    get mapElement(): HTMLElement | undefined {
        return this._mapElement.value;
    }

    set mapElement(value: HTMLElement | undefined) {
        this._mapElement.value = value;

        this.setMapElementSize();
    }

    setMapElementSize() {
        if (this._mapElement.value !== undefined) {
            const boundingClientRect = (this._mapElement.value as HTMLElement).getBoundingClientRect();

            this._mapElementWidth.value = boundingClientRect.width;
            this._mapElementHeight.value = boundingClientRect.height;
        }
    }

    get listElement(): HTMLElement | undefined {
        return this._listElement.value;
    }

    set listElement(value: HTMLElement | undefined) {
        this._listElement.value = value;

        this.setListElementSize();
    }

    setListElementSize() {
        if (this._listElement.value !== undefined) {
            const boundingClientRect = (this._listElement.value as HTMLElement).getBoundingClientRect();

            this._listElementWidth.value = boundingClientRect.width;
            this._listElementHeight.value = boundingClientRect.height;
        }
    }

    get listInnerElement(): HTMLElement | undefined {
        return this._listInnerElement.value;
    }

    set listInnerElement(value: HTMLElement | undefined) {
        this._listInnerElement.value = value;

        this.setListInnerElementSize();
    }

    get mapElementWidth(): number {
        return this._mapElementWidth.value;
    }

    get mapElementHeight(): number {
        return this._mapElementHeight.value;
    }

    get listElementWidth(): number {
        return this._listElementWidth.value;
    }

    get listElementHeight(): number {
        return this._listElementHeight.value;
    }

    get listInnerElementWidth(): number {
        return this._listInnerElementWidth.value;
    }

    get listInnerElementHeight(): number {
        return this._listInnerElementHeight.value;
    }

    setListInnerElementSize() {
        if (this._listInnerElement.value !== undefined) {
            const boundingClientRect = (this._listInnerElement.value as HTMLElement).getBoundingClientRect();

            this._listInnerElementWidth.value = boundingClientRect.width;
            this._listInnerElementHeight.value = boundingClientRect.height;
        }
    }

    check() {
        const mediaQuery = window.matchMedia('(max-width: 768px)');

        if (mediaQuery.matches) {
            return true;
        }

        return false;
    }
}

export const useComponentDimensions = new DimensionComposition();

